var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideoChange = function SvgVideoChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "video_change_svg__st0",
    d: "m19.8 2.6-2.9 1V2.5c0-.4-.3-.7-.7-.7H4.4c-.4 0-.7.3-.7.7v8.3c0 .4.3.7.7.7h11.8c.4 0 .7-.3.7-.7V9.6l2.9 1c.3.1.6-.1.6-.3V3c-.1-.3-.4-.4-.6-.4zM9.4 17.9c-4.5-.6-7.8-2.9-7.8-5.4 0-.7.1-1.3.6-2l-.9-1.1c-.8 1-1.3 2.1-1.3 3.2 0 3.3 3.8 6.1 9.2 6.9h.1c.4 0 .7-.3.8-.7 0-.4-.3-.8-.7-.9zM24 12.6c0-1.2-.4-2.2-1.3-3.2l-.9 1.2c.6.7.7 1.2.7 1.9 0 2.4-3.3 4.7-7.7 5.3l1.8-1.5c.3-.3.4-.8.1-1.1-.3-.2-.7-.2-1.1 0l-3.7 3c-.2.2-.3.4-.3.6 0 .2.1.5.3.6l3.9 2.6c.1.1.3.1.4.1.2 0 .5-.1.6-.3.2-.4.1-.8-.2-1.1l-2-1.3c5.6-.7 9.4-3.5 9.4-6.8z"
  })));
};
export default SvgVideoChange;